module.exports = __webpack_public_path__ + "img/tripS-logo.fa0f414a.svg";